import { WidgetOption, WidgetStyle, WidgetType } from '@/types'

export default {
  key: 'unknown',
  name: '未知',
  type: WidgetType.UNKNOWN,
  style: WidgetStyle.UNKNOWN,
  icon: 'fa-icon-unknown',
  width: 100,
  height: 100
} as WidgetOption
